import { API_ERROR_CODES, ONBOARDING_API_BASE_URL } from './index.ts';

/**
 * Resend OTP code
 */

type ApiOtpResendResult = {
  data?: {
    message: string;
  };
  errorCode?: API_ERROR_CODES;
  errorMessage?: string;
};

export const apiOtpResend = async (
  csrfToken: string,
  jid: string | null,
  language: string,
  region: string
): Promise<ApiOtpResendResult> => {
  return fetch(`${ONBOARDING_API_BASE_URL}/auth/otp/resend`, {
    method: 'POST',
    body: JSON.stringify({ jid, language, region }),
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        const errorMessage = await response.text();
        return {
          errorCode: API_ERROR_CODES.GENERIC,
          errorMessage,
        };
      }

      const responseJson = await response.json();

      return { data: responseJson } as ApiOtpResendResult;
    })
    .catch(() => ({
      errorCode: API_ERROR_CODES.GENERIC,
    }));
};
